import { useEffect } from 'react';
import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';

const useDeleteCart = () => {
  const { t } = useTranslation(LOCALIZATION_PAGES.PURCHASE_CART);
  const { showNotification } = useRoot();

  const [{ result: deleteResultCart, loading: loadingDeleteCart, error: errorDeleteCart }, deleteCart] = useApi(
    `${API_ENDPOINTS.CART}`,
    {
      initialFetch: false,
      verb: HTTP_VERBS.DELETE,
    }
  );

  useEffect(() => {
    if (errorDeleteCart) {
      showNotification(
        {
          message: t('alert_delete_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [errorDeleteCart, showNotification, t]);

  useEffect(() => {
    if (deleteResultCart) {
      showNotification({
        message: t('alert_delete_success'),
      });
    }
  }, [deleteResultCart, showNotification, t]);

  return [{ deleteResultCart, loadingDeleteCart, errorDeleteCart }, deleteCart];
};

export default useDeleteCart;
